import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import ReactGA from "react-ga4";
import {useAuth} from "../context/auth";
import {AppRoutes} from "../utils/constants";

export default function BaseComponent ({component: Component, ...props }) {
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuth();

    useEffect(() => {
        if (!auth.initializing && auth?.currentUser && !auth?.currentUser.activated && location.pathname !== AppRoutes.completeProfile.path) {
            console.log('navigate');
            navigate(AppRoutes.completeProfile.path);
        }

        //Then tracks the users as they navigate through the site
       ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location, auth]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location?.pathname]);

    return <Component {...props} />;
}
